import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  // Select,
  // MenuItem,
  // Checkbox,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Dialog,
  // ListItemText,
  // InputLabel,
  // Autocomplete,
  // TextField,
  //IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  //TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

//import CheckCircleIcon from "@mui/icons-material/CheckCircle";
//import DoneAllIcon from "@mui/icons-material/DoneAll";

//import SuiInput from "components/SuiInput";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";

import TarifasApi from "api/tarifasApi";

const NovedadesProcesoModal = ({ open, onClose, tarifa }) => {
  const [error, setError] = useState(undefined);
  const [limitesTarifa, setLimitesTarifa] = useState([]);
  //let user = localStorage.getItem("user");
  //user = JSON.parse(user);

  const fetchLimitesTarifa = async () => {
    try {
      const response = await TarifasApi.obtenerLimitesTarifa(tarifa.id);
      setLimitesTarifa(response.data);
    } catch (error) {
      console.error("Error al obtener los Limites de la Tarifa:", error);
      setError(obtenerMensajeError(error, "Error al obtener los Limites de la Tarifa."));
    }
  };

  useEffect(() => {
    if (tarifa) {
      fetchLimitesTarifa();
    }
  }, [tarifa]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validaciones
    // if (selectedTipo == null) {
    //   setError("Debes seleccionar un Tipo de Novedad.");
    //   return;
    // }
    try {
      console.log("tarifa: " + tarifa);
    } catch (error) {
      console.error("Error al registrar la Novedad:", error);
      setError(obtenerMensajeError(error, "Error al registrar la Novedad."));
    }
  };

  const hCClose = () => {
    setError(undefined);
    onClose();
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  return (
    <Dialog open={open} onClose={hCClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <h2>REGISTRAR LIMITE DE TARIFA</h2>
        <h3>TARIFA: {tarifa ? tarifa?.nombre : "No tiene Tarifa"}</h3>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
            </Grid>
          </Grid>
          <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}></Grid>
            <Grid size={6}></Grid>
          </Grid>
          <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}></Grid>
            <Grid size={6}></Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <SuiButton onClick={hCClose} buttonColor="light">
            Cancelar
          </SuiButton>
          <SuiButton type="submit" variant="gradient" buttonColor="dark">
            Registrar
          </SuiButton>
        </DialogActions>

        {/* Sección de Novedades */}
        <DialogContent>
          <SuiBox mt={2}>
            <strong>Limites de la Tarifa: {tarifa ? tarifa?.nombre : "No tiene Tarifa"}</strong>
          </SuiBox>
          <SuiBox mt={1}>
            {limitesTarifa.length > 0 ? (
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <strong>Nombre</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Límite Inferior</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Límite Superior</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Valor a Cobrado</strong>
                      </TableCell>
                    </TableRow>
                    {limitesTarifa.map((limiteTarifa, index) => (
                      <TableRow key={index}>
                        <TableCell>{limiteTarifa.nombre}</TableCell>
                        <TableCell>{limiteTarifa.cant_inferior}</TableCell>
                        <TableCell>{limiteTarifa.cant_superior}</TableCell>
                        <TableCell>{formatCurrency(limiteTarifa.valor_cobrado)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Alert severity="info">No hay Límites de Tarifa registrados.</Alert>
            )}
          </SuiBox>
        </DialogContent>
      </form>
    </Dialog>
  );
};

NovedadesProcesoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  tarifa: PropTypes.object,
  onSuccess: PropTypes.func.isRequired,
};

export default NovedadesProcesoModal;
